/*
 * Created by yvesb on 21/10/2025.
 */
/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * https://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

import MtgDlg from './MtgDlg'
import { ce, ceIn } from '../kernel/dom'
import $ from 'jquery'
import { getStr } from '../kernel/kernel'
import { getMtgInput } from './dom'
import EditeurConst from './EditeurConst'
export default MarqueAngDlg

/**
 * Dialogue de modification d'une marque d'angle en donnant son rayon en pixels.
 * N'est appelée qu'une fois que la marque a été créé.
 * Modifier manuellement le rayon d'une marque d'angle peut être utile pour que
 * des marques d'angles aient toutes la même dimension
 * @param {MtgApp} app
 * @param {CMarqueAngleAncetre} marqueAngle
 * @param {function} callBackOK null ou fonction de callBack à appeler après OK
 * @param {function} callBackCancel null ou fonction de callBack à appeler après annumlation
 * @constructor
 */
function MarqueAngDlg (app, marqueAngle, callBackOK, callBackCancel) {
  MtgDlg.call(this, app, 'MarqueAngDlg', callBackOK, callBackCancel)
  this.marqueAngle = marqueAngle
  const self = this
  const tab = ce('table')
  this.appendChild(tab)
  let tr = ceIn(tab, 'tr')
  let td = ceIn(tr, 'td')
  let label = ceIn(td, 'label')
  $(label).html(getStr('RayonMarque'))
  const input = getMtgInput({
    id: 'mtginput',
    size: 5 // 4 pas assez grand pour iPad
  })
  td = ceIn(tr, 'td')
  td.appendChild(input)
  input.onkeyup = function (ev) {
    if (ev.keyCode === 13) {
      $(this).blur() // Nécessaire sur ipad pour une raison que j'ignore
      self.OK()
    }
  }
  $(input).val(Math.round(marqueAngle.rayon))
  // setSelectionRange marche pas sur un type number, faut utiliser select(),
  // mais pas sûr que ça fonctionne sur iPad…
  input.select()
  tr = ceIn(tab, 'tr')
  label = ceIn(tr, 'label')
  $(label).html('   (4 -> 600)')
  this.editeur = new EditeurConst(app, input, 4, 600)
  this.create('MarqueAng', 500)
}

MarqueAngDlg.prototype = new MtgDlg()

MarqueAngDlg.prototype.onOpen = function () {
  MtgDlg.prototype.onOpen.call(this, 'mtginput')
}

MarqueAngDlg.prototype.OK = function () {
  const ray = parseInt($('#mtginput').val())
  if (this.editeur.validate()) {
    this.marqueAngle.rayon = ray
    if (this.callBackOK !== null) this.callBackOK()
    this.app.gestionnaire.enregistreFigureEnCours('ModifObj')
    this.destroy()
  }
}
